import CircularProgress from '@mui/material/CircularProgress'
import cn from 'classnames'
import Icon from '../../Common/Icon'
import IconButton from '../../Common/IconButton'
import Text from '../../Common/Text'
import styles from './RegionScreenshotPreview.module.scss'

interface IProps {
  isCapturing: boolean
  hasFailed: boolean
  screenshot: string | null
  failedMessage: string
  onClear: () => void
  className?: string
}

// The selected area's slot: in flight, failed, or its image with a remove button.
const RegionScreenshotPreview = ({
  isCapturing,
  hasFailed,
  screenshot,
  failedMessage,
  onClear,
  className,
}: IProps) => {
  if (isCapturing) {
    return (
      <div className={cn(styles.preview, styles.loading, className)}>
        <CircularProgress size={20} />
        <Text variant="bodySm" component="span">
          Capturing screenshot…
        </Text>
      </div>
    )
  }
  if (hasFailed) {
    return (
      <div className={cn(styles.preview, styles.error, className)}>
        <Text variant="bodySm" component="span" casing="role">
          {failedMessage}
        </Text>
        <IconButton
          title="Dismiss capture error"
          box="xs"
          className={styles.removeBtn}
          onClick={onClear}
        >
          <Icon name="x" size="xs" />
        </IconButton>
      </div>
    )
  }
  if (!screenshot) return null
  return (
    <div className={cn(styles.preview, className)}>
      <img src={screenshot} alt="Selected region preview" />
      <IconButton title="Remove screenshot" box="xs" className={styles.removeBtn} onClick={onClear}>
        <Icon name="x" size="xs" />
      </IconButton>
    </div>
  )
}

export default RegionScreenshotPreview
